<template>
  <Page>
    <ManageOrderBanner
      :bannerName.sync="bannerName"
      :allItems.sync="data.allItems"
      :selectedIndex.sync="selectedIndex" />
    <ManageBannerMetadata
      v-if="data.allItems.length"
      :selectedIndex="selectedIndex"
      :allItems.sync="data.allItems"
      :item.sync="data.allItems[selectedIndex]" />
    <EmptyMessage
      v-if="!data.allItems.length">
      <h3>ไม่มีแบนเนอร์</h3>
    </EmptyMessage>
  </Page>
</template>

<script>
import _ from 'lodash';
import Page from '@/layouts/Page.vue';
import EmptyMessage from '@/components/EmptyMessage.vue';

import BannerMixins from '../mixins';
import ManageOrderBanner from './components/ManageOrderBanner.vue';
import ManageBannerMetadata from './components/ManageBannerMetadata.vue';

export default {
  props: {
    data: {
      type: Object,
      required: true,
    },
    bannerName: {
      type: String,
      required: true,
    },
  },
  components: {
    ManageBannerMetadata,
    ManageOrderBanner,
    Page,
    EmptyMessage,
  },
  data() {
    return {
      selectedIndex: 0,
      showAddBannerItemModal: false,
      showLoadFromAPIModal: false,
      allocatedDate: [],
    };
  },
  mixins: [BannerMixins],
  created() {
    if (this.data) {
      this.reSort();
    }
  },
  methods: {
    reSort() {
      const showing = this.getBannerStatusByStatus(this.data.allItems, 'showing');
      const pending = this.getBannerStatusByStatus(this.data.allItems, 'pending');
      const ended = this.getBannerStatusByStatus(this.data.allItems, 'ended');

      let allItems = [];
      if (showing.length) {
        allItems = [...showing];
      }
      allItems = [...allItems, ...pending, ...ended];

      this.$emit('update:data', { ...this.data, allItems });
    },
    getBannerStatusByStatus(allItems, status) {
      return _.chain(allItems)
        .filter((item) => {
          return this.getBannerStatus(item) === status;
        })
        .sortBy(['startPublish'])
        .value();
    },
  },
};
</script>

<style lang="scss" scoped>
.empty-message-container {
  background: #FFF;
}
</style>
